// Curated private views at /#/for/:slug — edit this file to add recipients.
// Match `curatedTargetUrls` and optional `additionalTargetUrls` to each project’s
// `targetUrl` in `src/data/projectsData.js` (leading slash optional).

export const PRIVATE_RECIPIENTS = {
  "cooper-hewitt": {
    companyName: "Apple - IDG",
    headline: "Work selected for the Computational Designer role @IDG",
    body:
      "Below are a few projects chosen for the role we discussed, with additional work below that. The résumé here is tailored for you—email me if you would like to talk.",
    resumeUrl: "/General/Shareef Jasim _ Resume.pdf",
    resumeDownloadName: "Shareef-Jasim-Resume-Cooper-Hewitt.pdf",
    email: "shareefjasim1@gmail.com",
    emailSubject: "Cooper Hewitt · portfolio",
    curatedTargetUrls: [
      "/TheCutaway",
      "/ECHO",
      "/FourSeasonsFacade",
      "/SILTMiddelkerke",
      "/CliffYouthCenter",
    ],
    // Optional: order for projects not in `curatedTargetUrls`. Any base project
    // omitted here still appears after these, in default `projectsData` order.
    additionalTargetUrls: [
      "/WEAVE",
      "/APETools",
      "/CTEP",
      "/DropletsClash",
      "/CowesWeekPavilion",
      "/GENxFacadeSolution",
    ],
  },
};
